<template>
  <div class="custom-button-group">
    <slot />
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const show = () => {}
    return {
      show
    }
  }
})
</script>
<style lang="less">
@color-primary: #1677ff;
@color-success:#52c41a;
@color-warning:#faad14;
@color-error:#ff4d4f;

.custom-button-group {
  display: flex;
  button {
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0px 10px;
    border: 1px solid;
    &.icon-button {
      font-size: 10px;
      line-height: 20px;
    }
    &.primary {
      border-color: rgba(@color-primary, 0.5);
      background: rgba(@color-primary, 0.05);
      color: rgba(@color-primary, 0.5);
    }
    &.success {
      border-color: rgba(@color-success, 0.5);
      background: rgba(@color-success, 0.05);
      color: rgba(@color-success, 0.5);
    }
    &.normal {
      border-color: rgba(@color-warning, 0.5);
      background: rgba(@color-warning, 0.1);
      color: rgba(@color-warning, 0.5);
    }
    &.delete {
      border-color: rgba(@color-error, 0.5);
      background: rgba(@color-error, 0.05);
      color: rgba(@color-error, 0.5);
    }
    &:hover {
      &.primary {
        border-color: rgba(@color-primary, 0.5);
        background: rgba(@color-primary, 0.5);
        color: #ffffff;
      }
      &.success {
        border-color: rgba(@color-success, 0.5);
        background: rgba(@color-success, 0.5);
        color: #ffffff;
      }
      &.normal {
        border-color: rgba(@color-warning, 0.5);
        background: rgba(@color-warning, 0.5);
        color: #ffffff;
      }
      &.delete {
        border-color: rgba(@color-error, 0.5);
        background: rgba(@color-error, 0.5);
        color: #ffffff;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .iconfont {
      font-size: 12px;
    }
    &:not(:first-child):not(:last-child) {
      /* 样式 */
      border-left: none;
      border-right: none;
    }
    &:nth-child(1) {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-left: none;
      border-radius: 0 4px 4px 0;
    }
    &.onlyOne {
      border: 1px solid;
      border-radius: 4px;
    }
  }
}
</style>
